import React from 'react'

import UploadIcon from 'assets/svgr-icons/Upload.svg'
import { ButtonWithIcon } from 'common-components'
import MediaUploadButton from 'components/MediaUploadButton'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { useAudioUpload } from 'hooks/project-item-upload'

export const AudioUploadBtn: React.FC = () => {
  const handleFilesUpload = useAudioUpload()

  return (
    <MediaUploadButton acceptType="audio" handleFilesUpload={handleFilesUpload}>
      <ButtonWithIcon
        icon={<UploadIcon />}
        onClick={() => {}}
        label={translate(T.UPLOAD_LABEL)}
      />
    </MediaUploadButton>
  )
}
